import React from 'react';
import { IIconProps } from '../interfaces';
import { useTheme } from '@chakra-ui/react';

const AleaRestoreIcon: React.FC<IIconProps> = ({
  color,
  size = '24',
}) => {
  const theme = useTheme();
  const iconColor = color || theme.colors.alea[500];
  const width = parseInt(String(size), 10);
  const height = (27 / 24) * width;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.14038 15.0448C2.14038 14.4925 1.69267 14.0448 1.14038 14.0448C0.588096 14.0448 0.140381 14.4925 0.140381 15.0448H2.14038ZM21.2299 15.0448C21.2299 20.3162 16.9566 24.5895 11.6851 24.5895V26.5895C18.0611 26.5895 23.2299 21.4208 23.2299 15.0448H21.2299ZM11.6851 24.5895C6.41372 24.5895 2.14038 20.3162 2.14038 15.0448H0.140381C0.140381 21.4208 5.30915 26.5895 11.6851 26.5895V24.5895ZM11.6851 5.5C16.9566 5.5 21.2299 9.77334 21.2299 15.0448H23.2299C23.2299 8.66877 18.0611 3.5 11.6851 3.5V5.5ZM11.6851 3.5H3.78819V5.5H11.6851V3.5Z"
        fill="white"
      />
      <path
        d="M11.3035 10.1865V15.9023H16.0672"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M6.29845 1.59082L3.3894 4.49987L6.29845 7.40892"
        stroke={iconColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default AleaRestoreIcon; 